module.exports = __webpack_public_path__ + "static/media/lateral-flexion-up.2d1d15cc.png";